import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  minBreakpointQuery,
} from '../styles';
import { Button, HtmlContent } from './ui';

const StyledImageContentCard = styled.article``;

const StyledInner = styled.div``;

const StyledIllustrationWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  aspect-ratio: 1/1;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 80%;
    background: ${brandColours.septenary};
    border-radius: 15px;
  }
`;

const StyledIllustration = styled.img`
  position: relative;
  z-index: 1;
  padding: 15px 30px;
  height: 100%;
  width: 100%;
`;

const StyledImage = styled(GatsbyImage)`
  border-radius: 15px;
`;

const StyledHeading = styled.h3`
  margin-top: 20px;
  color: ${brandColours.secondary};
  font-weight: ${fontWeights.semibold};
  ${fontSize(20)};

  ${minBreakpointQuery.small`
    margin-top: 25px;
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
    ${fontSize(24)};
  `};
`;

const StyledText = styled(HtmlContent)`
  margin-top: 14px;

  ${minBreakpointQuery.small`
    margin-top: 18px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 22px;
  `};

  a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const StyledButton = styled(Button)`
  margin-top: 14px;

  ${minBreakpointQuery.small`
    margin-top: 18px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 22px;
  `};
`;

const ImageContentCard = ({ image, heading, text, link, ...props }) => (
  <StyledImageContentCard {...props}>
    <StyledInner>
      {image.format === 'svg' ? (
        <StyledIllustrationWrapper>
          <StyledIllustration src={image.url} alt={image.alt} loading="lazy" />
        </StyledIllustrationWrapper>
      ) : (
        <StyledImage image={image.gatsbyImageData} alt={image.alt} />
      )}
      <StyledHeading>{heading}</StyledHeading>
      <StyledText content={text} />
      {link && <StyledButton to={link.pageUrl}>{link.text}</StyledButton>}
    </StyledInner>
  </StyledImageContentCard>
);

export default ImageContentCard;
